import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './_A.scss';

/**
 * An a element component which wraps a HTML anchor and adds to it the basic bootstrap css rules.
 * All arbitrary DOM properties and attributes (including event handlers) are accepted and passed to HTML a element.
 */
const A = props => {
  const { className, children, innerRef, ...rest } = props;
  const classes = classNames('B360A', className);
  return (
    <a className={classes} ref={innerRef} {...rest}>
      {children}
    </a>
  );
};

A.propTypes = {
  /**
   * A custom className for the component
   */
  className: PropTypes.string,
  /**
   * The component's children
   */
  children: PropTypes.node,
  /**
   * a ref handled by the native html element
   */
  innerRef: PropTypes.func
};

export default A;
